import script from "./ArticleWikipedia.vue?vue&type=script&setup=true&async=true&lang=js"
export * from "./ArticleWikipedia.vue?vue&type=script&setup=true&async=true&lang=js"

import "./ArticleWikipedia.vue?vue&type=style&index=0&id=49edb3d3&lang=css"

const __exports__ = script;

export default __exports__